export default __webpack_public_path__ + "static/media/ogp-logo-mark-white.371dbfae.svg";